"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotomeasureCollectionList = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const mobx_1 = require("mobx");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const mithril_component_1 = require("../../components/mithril.component");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const page_1 = require("../../page/page");
const page_state_1 = require("../../state/page.state");
const tag_sort_state_1 = require("../../state/tag.sort.state");
const store_1 = require("../../store");
const capture_bar_1 = require("../capture.bar/capture.bar");
const collection_list_1 = require("../collection.list/collection.list");
const collection_toolbar_1 = require("../collection.toolbar/collection.toolbar");
const tag_map_1 = require("../tag.map/tag.map");
const photomeasure_collection_list_style_1 = require("./photomeasure.collection.list.style");
const photomeasure_map_overlay_1 = require("./photomeasure.map.overlay");
(0, theme_1.addStyles)(photomeasure_collection_list_style_1.Style);
class PhotomeasureCollectionList extends mithril_component_1.IMithrilStateComponent {
    get inspectedCapture() {
        var _a;
        const { inspectedCaptureId, inspectedCollectionRevision } = page_state_1.CurrentState;
        if (inspectedCaptureId && inspectedCollectionRevision) {
            return (_a = store_1.AppStore.Collection.get(inspectedCollectionRevision)) === null || _a === void 0 ? void 0 : _a.state.getCapture(inspectedCaptureId);
        }
        return null;
    }
    constructor(state) {
        super();
        this.state = state;
        this.toolbar = new collection_toolbar_1.CollectionToolbar(this.state, {
            mapZoomOut: false,
            title: i18n_1.T.COLLECTION_TITLE
        });
        this.map = new tag_map_1.TagMap(this.state);
        this.overlay = new photomeasure_map_overlay_1.PhotomeasureMapOverlay({
            capture: this.inspectedCapture
        });
        this.reaction(() => this.collection, this.ensureCollectionSelected);
        this.reaction(() => this.inspectedCapture, () => {
            const current = (0, lodash_1.get)(this.overlay, ['capture', 'objectId'], null);
            const next = (0, lodash_1.get)(this, ['inspectedCapture', 'objectId'], null);
            if (next !== current) {
                this.overlay.setCapture(this.inspectedCapture);
            }
        });
    }
    get nodes() {
        const collectionSummaries = this.visibleCollections;
        if (collectionSummaries == null) {
            return (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: `${photomeasure_collection_list_style_1.CSS.collections.content} ${photomeasure_collection_list_style_1.CSS.collections.isEmpty}` }, collection_list_1.CollectionList.viewLoading(page_state_1.CurrentState.inspectedTagId)),
                capture_bar_1.CaptureBar.view()
            ]);
        }
        const tag = store_1.AppStore.Tag.get(page_state_1.CurrentState.inspectedTagId);
        const inspectedCollection = this.collection;
        return (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.collections.container }, [
                (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.toolbar.container }, this.toolbar.view()),
                (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.collections.content }, [
                    collection_list_1.CollectionList.view(this.state, tag, collectionSummaries),
                    capture_bar_1.CaptureBar.view(inspectedCollection)
                ])
            ]),
            (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.map.container }, this.map.view()),
            this.viewMapButton(inspectedCollection)
        ]);
    }
    get visibleCollections() {
        if (page_state_1.CurrentState.inspectedTagId == null || store_1.AppStore.Tag.get(page_state_1.CurrentState.inspectedTagId) == null) {
            return null;
        }
        const tagSummary = store_1.AppStore.TagSummary.get(page_state_1.CurrentState.inspectedTagId);
        const revisions = tagSummary != null ? tagSummary.revisions : [];
        const collectionSummaries = [];
        for (const revision of revisions) {
            const collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
            if (collectionSummary != null) {
                collectionSummaries.push(collectionSummary);
            }
        }
        tag_sort_state_1.TagSortState.sortSummaries(collectionSummaries);
        page_state_1.CurrentState.Tag.resetLastSelectedCollectionIndex();
        page_state_1.CurrentState.Tag.setExpandedCollectionsUUIDs(collectionSummaries.map(_ => _.uuid));
        return collectionSummaries;
    }
    ensureCollectionSelected() {
        const tagId = page_state_1.CurrentState.inspectedTagId;
        const tagSummary = store_1.AppStore.TagSummary.get(tagId);
        page_state_1.CurrentState.setInspectedTagId(tagId);
        if (tagSummary != null && tagSummary.revisions.indexOf(page_state_1.CurrentState.inspectedCollectionRevision) === -1) {
            page_state_1.CurrentState.setInspectedCollection(tagSummary.revisions[0]);
        }
    }
    viewMapButton(collection) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.MAP, {
            className: photomeasure_collection_list_style_1.CSS.map.button,
            title: i18n_1.T.NAVIGATE_MAP,
            type: 'a',
            href: page_1.IkePageName.map,
            hrefParams: collection != null ? { t: collection.jobId, collection: collection.uuid } : null
        });
    }
    get collection() {
        if (page_state_1.CurrentState.CollectionEdit.isEditing) {
            return page_state_1.CurrentState.CollectionEdit.collection;
        }
        return store_1.AppStore.Collection.get(page_state_1.CurrentState.inspectedCollectionRevision);
    }
}
exports.PhotomeasureCollectionList = PhotomeasureCollectionList;
tslib_1.__decorate([
    mobx_1.computed
], PhotomeasureCollectionList.prototype, "inspectedCapture", null);
tslib_1.__decorate([
    mobx_1.computed
], PhotomeasureCollectionList.prototype, "visibleCollections", null);
tslib_1.__decorate([
    mobx_1.action.bound
], PhotomeasureCollectionList.prototype, "ensureCollectionSelected", null);
tslib_1.__decorate([
    mobx_1.computed
], PhotomeasureCollectionList.prototype, "collection", null);
//# sourceMappingURL=photomeasure.collection.list.js.map